import { render, staticRenderFns } from "./InputMemo.vue?vue&type=template&id=35845956&"
import script from "./InputMemo.vue?vue&type=script&lang=js&"
export * from "./InputMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports